import type { EnvVarType } from '@stratumn/studio-shared';
import { Input } from '@/components/ui/input';
import { BooleanToggleCell } from './BooleanToggleCell';

type EnvVarValueCellProps = {
  type: EnvVarType;
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  /**
   * Placeholder shown in the input when `value` is empty. Used by workspace
   * overrides to surface the process-level default value as a hint.
   */
  placeholder?: string;
};

export const EnvVarValueCell = ({
  type,
  value,
  onChange,
  readOnly = false,
  placeholder = 'value'
}: EnvVarValueCellProps) => {
  if (type === 'boolean') {
    return (
      <BooleanToggleCell
        disabled={readOnly}
        onChange={next => onChange(next ? 'true' : 'false')}
        value={value === 'true'}
      />
    );
  }

  return (
    <Input
      className="h-10 w-full rounded-none border-0 font-mono shadow-none focus-visible:ring-0"
      disabled={readOnly}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      type={type === 'number' ? 'number' : 'text'}
      value={value}
    />
  );
};
